import { Controller } from "@hotwired/stimulus"

export default class DataLayerController extends Controller {
  static values = {
    eventName: String,
    ecommerce: Object,
    transactionId: String,
  }

  initialize() {
    this.ensureDataLayer()
  }

  connect() {
    if (!this.hasEventNameValue) {
      return
    }

    if (this.eventNameValue === "purchase") {
      this.purchase()
      return
    }

    this.pushEvent(this.eventNameValue)
  }

  addPaymentInfo() {
    const acceptTerms = document.getElementById("accept_terms")

    if (!acceptTerms || !acceptTerms.checked) {
      return
    }

    this.pushEvent("add_payment_info")
  }

  purchase() {
    const ecommerceTransactionId = this.hasEcommerceValue ? this.ecommerceValue.transaction_id : null
    const transactionId = this.transactionIdValue || ecommerceTransactionId || "purchase"

    if (!this.allowSingleEvaluation(`purchase_${transactionId}`)) {
      return
    }

    this.pushEvent("purchase")
  }

  pushEvent(eventName) {
    if (!this.hasEcommerceValue) {
      return
    }

    this.ensureDataLayer()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: eventName,
      ecommerce: this.ecommerceValue,
    })
  }

  allowSingleEvaluation(key) {
    const cookieName = `ase_${key}`.toLowerCase()

    if (document.cookie.split(";").some((cookie) => cookie.trim().startsWith(`${cookieName}=`))) {
      return false
    }

    const expiry = new Date()
    expiry.setTime(expiry.getTime() + (30 * 24 * 60 * 60 * 1000))
    document.cookie = `${cookieName}=true;expires=${expiry.toUTCString()};path=/`

    return true
  }

  ensureDataLayer() {
    window.dataLayer = window.dataLayer || []
  }
}
